import React, { useContext } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import "../../stylesheet/forms.css";
import ContextApi from "../../context/ContextApi";
import ToastContext from "../../context/toasterContex";
import {
  getSelectedAppointment,
  addPartner,
  editPartner,
} from "../../Utils/localStore";

export default function PartnerSummary(props) {
  const { toast } = useContext(ToastContext);
  const navigate = useNavigate();
  const {
    appointment,
    partner,
    setPartner,
  } = useContext(ContextApi);
  
  const [searchParams] = useSearchParams();
  const queryParams = searchParams.get("mode");
//   const edit = queryParams;


  const handleSubmit = async (e) => {
    e.preventDefault();
    const newPartner = {
      ...partner,
    };
    newPartner.status = "Active";
    let today = Date.now();
    const formatter = new Intl.DateTimeFormat([], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    today = formatter.format(today);
    newPartner.joinedDate = today;
    newPartner.synced = false;
    await addPartner(newPartner);
    toast.success("Partner Added successfully", {
      position: toast.POSITION.TOP_CENTER,
    });
    navigate("/partners/partner-report");
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const newPartner = {
      ...partner,
    };
    const resp = await editPartner(newPartner).then((resp) => {
      if (resp) {
        toast.success("Partner Updated successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate("/partners/partner-report");
      }
    });
  };

  return (
    <div>
      <div className="p-4">
        <h1 className="text-sky-500 text-3xl mt-10 font-bold ">
          Partner Summary
        </h1>
        <p className="pt-4">
          Review partner information before confirming entry.
        </p>
      </div>

      <div className="flex justify-center flex-col-reverse lg:flex-row p-4 lg:p-0 gap-5">
        <div className="w-full lg:w-4/5 h-[470px] overflow-y-auto mt-8 summary-steps">
          <h1 className=" font-bold mb-3">Parner Details</h1>
          <div className="border border-gray-400 rounded-md w-[550px] p-3">
            <div>
              <h4 className="text-gray-400">Name</h4>
              <p className="capitalize">{partner?.partnerName ?? "-"}</p>
            </div>

            <div>
              <h4 className="text-gray-400 mt-4">Email address:</h4>
              <p>{partner?.email ?? "-"}</p>
            </div>

            <div>
              <h4 className="text-gray-400 mt-4">Phone number</h4>
              <p>{partner?.phoneNumber ?? "-"}</p>
            </div>

            <div>
              <h4 className="text-gray-400 mt-4">Partner ID</h4>
              <p>{partner?.partnerID ?? "-"}</p>
            </div>

            <div>
              <h4 className="text-gray-400 mt-4">Partner ID</h4>
              <p>{partner?.partnerType ?? "-"}</p>
            </div>

            <div>
              <h4 className="text-gray-400 mt-4"> Address</h4>
              <p>{partner?.address ?? "-"}</p>
            </div>
          </div>

          <h1 className="font-bold mb-3 mt-5">Contact Personel</h1>
          <div className="border rounded-md lg:w-[550px] mb-24 p-3">
            <div>
              <h4 className="text-gray-400">Contact Name</h4>
              <p>{partner?.contactName ?? "-"}</p>
            </div>

            <div>
              <h4 className="text-gray-400 mt-4"> Contact Phone</h4>
              <p>{partner?.contactPhone ?? "-"} </p>
            </div>

            <div>
              <h4 className="text-gray-400 mt-4"> Contact Email</h4>
              <p>{partner?.contactEmail ?? "-"} </p>
            </div>
            <div>
              <h4 className="text-gray-400 mt-4">Note</h4>
              <p>{partner?.note ?? "-"}</p>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/5">
          <div className="mt-3">
            <button
              className="border-sky-600 border text-sky-500 mb-4 p-2 w-36 rounded"
              onClick={props.onBack}
            >
              {queryParams ? "Edit" : "Back"}
            </button>

            {queryParams ? (
              <button
                className="bg-sky-600 text-white mb-4 p-2 w-36 rounded ml-4 lg:ml-0"
                onClick={(e) => handleUpdate(e)}
              >
                Update
              </button>
            ) : (
              <button
                className="bg-sky-600 text-white mb-2 p-2 w-36 rounded ml-4 lg:ml-0"
                onClick={(e) => handleSubmit(e)}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
